import { c as _c } from "react/compiler-runtime";
import { TEAMS_MEMBER_COUNT_FILTER_LABEL, TEAMS_SPECIFIC_MEMBERS_FILTER_LABEL } from "@components/teams/teams-filters/teams-filter-constants";
import { ChevronRightIcon, MenuItem } from "@flat-ui";
import { Stack } from "@mui-wrapper";
import { PALETTE_VARS } from "@styles/palette-vars";

/** How the members filter of the teams filters: by the number of members, or by specific members */

/** The modes of the members filter, in the order they are offered */
const MODES = [{
  mode: "count",
  label: TEAMS_MEMBER_COUNT_FILTER_LABEL
}, {
  mode: "members",
  label: TEAMS_SPECIFIC_MEMBERS_FILTER_LABEL
}];
/** The items to pick how the members filter of the teams filters, each opening a view of its own */
export function TeamsMembersFilterModeList(t0) {
  const $ = _c(5);
  const {
    appliedMode,
    onModeClicked
  } = t0;
  let t1;
  if ($[0] !== appliedMode || $[1] !== onModeClicked) {
    t1 = MODES.map(t2 => {
      const {
        mode,
        label
      } = t2;
      return <MenuItem key={mode} disableRipple={true} selected={appliedMode === mode} onClick={() => onModeClicked(mode)}><Stack direction="row" sx={{
          flex: 1,
          alignItems: "center",
          justifyContent: "space-between",
          color: appliedMode === mode ? "primary.main" : "inherit"
        }}>{label}<ChevronRightIcon sx={{
            fontSize: "1rem",
            color: PALETTE_VARS.text.secondary
          }} /></Stack></MenuItem>;
    });
    $[0] = appliedMode;
    $[1] = onModeClicked;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <>{t1}</>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}